import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import {
	cameravideo,
	file,
	mic,
	videocall,
	videocall1,
	videocallicon,
} from "../Constant/Index";

const PhysicianVideoCall = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Video Call" />
			<section className="video-call">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="video-call position-relative">
								<div className="d-flex align-items-center gap-3 position-absolute right-0 top-0 p-3">
									<Link
										class="btn video-btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										href="/current-consultations-detail"
									>
										<span class="bg-wrapper w-100">
											<img src={file} className="img-fluid pe-3" alt="" /> View
											Write Notes
										</span>
									</Link>
									<Link
										class="btn video-btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										href="/current-consultations-detail"
									>
										<span class="bg-wrapper w-100">
											<img src={file} className="img-fluid pe-3" alt="" /> View
											Write Prescription
										</span>
									</Link>
								</div>
								<div className="user-call">
									<img src={videocall} className="img-fluid" alt="" />
								</div>
								<div className="incoming-call-physician position-absolute right-0 bottom-0 p-4">
									<img src={videocall1} className="img-fluid" alt="" />
								</div>
								<div className="position-video-call-wrapper-icon">
									<div className="video-icons d-flex align-items-center gap-3">
										<div className="icons-video">
											<img src={cameravideo} className="img-fluid" alt="" />
										</div>
										<div className="icons-video red-video-call">
											<img src={videocallicon} className="img-fluid" alt="" />
										</div>
										<div className="icons-video">
											<img src={mic} className="img-fluid" alt="" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianVideoCall;
